import React, { useState, useEffect } from 'react';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import './index.css';
import { responsiveClassName } from '../../utils/classNames';
function Heading({ profile }) {
  const [greeting, setGreeting] = useState('');
  const [displayText, setDisplayText] = useState('');

  const updateGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      setGreeting('Good morning');
    } else if (hour >= 12 && hour < 17) {
      setGreeting('Good afternoon');
    } else {
      setGreeting('Good evening');
    }
  };

  useEffect(() => {
    updateGreeting();
    const interval = setInterval(updateGreeting, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const firstLine = 'Manage your entire business';
    const secondLine = 'effortlessly on one platform';
    const fullText = firstLine + '\n' + secondLine;
    let index = 0;

    const typingInterval = setInterval(() => {
      setDisplayText(fullText.slice(0, index + 1));
      index++;

      if (index === fullText.length) {
        clearInterval(typingInterval);
      }
    }, 300);

    return () => clearInterval(typingInterval);
  }, []);

  return (
    <section className={tw`container mx-auto px-4`}>
      <div className={tw`py-4`}>
        <h2
          className={responsiveClassName(
            `font-bold text-black text-xl capitalize`,
            'font-bold text-black text-3xl capitalize'
          )}
        >
          {greeting}, {profile?.name}
        </h2>
        <div className=''>
          <h3
            className={responsiveClassName(
              `mt-4 font-bold text-3xl leading-12  max-w-3xl min-h-[150px]`,
              'mt-4 font-bold text-5xl leading-16  max-w-3xl min-h-[120px]'
            )}
          >
            <span style={{ whiteSpace: 'pre-wrap' }}>{displayText}</span>
            <span className='blink'>|</span>
          </h3>
        </div>
      </div>
    </section>
  );
}

export default Heading;
